import { render, staticRenderFns } from "./SelectAssessmentCenter.vue?vue&type=template&id=64b638a5&"
import script from "./SelectAssessmentCenter.vue?vue&type=script&lang=js&"
export * from "./SelectAssessmentCenter.vue?vue&type=script&lang=js&"
import style0 from "./SelectAssessmentCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports